// An explicit `behavior: 'smooth'` overrides the CSS `scroll-behavior` reset, so reduced motion is checked here.
export const smoothScrollBehavior = (): ScrollBehavior =>
    window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
